"use client";
import { useCallback, useState } from "react";

/**
 * For using a browser query parameter as a react state variable
 **/

export default function useTurnrCallbackRef() {
    const [refWithNode, setRefWithNode] = useState(null);
    let onRefChange = useCallback((node) => {
        if (node === null) {
            // DOM node referenced by ref has been unmounted
        } else {
            onRefChange.current = node;
            setRefWithNode({ current: node });
        }
    }, []);

    return refWithNode || onRefChange;
}
